import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { PaylinesSelector } from "../PaylinesSelector";
import { Paylines } from "../Paylines";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { StageController } from "../../Components/StageController";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { BaseView } from "../Base/BaseView";
import { WinAnimator2 } from "../../CustomComponents/WinAnimator2";
import { Tweens } from "../../Components/Effects/Tweens";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { TimelineElement } from "../../Components/Elements/Graphics/TimelineElement";
import { MachineExtended } from "../../CustomComponents/MachineExtended";
import { ImageTextCounterElement } from "../../Components/Elements/Texts/ImageTextCounterElement";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { LayoutManager } from "../../Managers/LayoutManager";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends LayoutContainerElement {
    public static LayoutManager: LayoutManager;

    static TotalWin: TimelineElement;

    private _controller: FreespinsController;

    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _paylinesSelector: PaylinesSelector;
    private _symbols: Symbols;
    private _machine: MachineExtended;
    private _winAnimator: WinAnimator2;
    private _noWinContainer: ContainerElement;
    private _winContainer: ContainerElement;

    private _highWinsAnim: SwitchElement;
    private _reelLines: SwitchElement;

    private _counters: SwitchElement;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        StageController.freespinsStageContainer = this;
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        BaseView.LayoutManager = new LayoutManager();

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                    if (this.childs["PaylinesTop"] != null) this._paylines.addTopContainer(this.childs["PaylinesTop"]);
                    this._paylines.reset();
                }

                if (this.childs[key] instanceof PaylinesSelector) {
                    this._paylinesSelector = this.childs[key];
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof MachineExtended) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimator) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "NoWinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._noWinContainer = this.childs[key];
                }

                if (key === "WinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._winContainer = this.childs[key];
                }
                if (key === "ReelsLines" && this.childs[key] instanceof SwitchElement) {
                    this._reelLines = this.childs[key];
                }
                if (key === "HighWinsAnimation" && this.childs[key] instanceof SwitchElement) {
                    this._highWinsAnim = this.childs[key];
                }
                FreespinsView.TotalWin = this.childs["TotalWin"];
            }

            this._counters = this.childs["Counters"];

            if (DEBUG) {
                if (this._paylines == null) {
                    this.log("WARNING no paylines");
                }

                if (this._symbols == null) {
                    this.log("ERROR no symbols");
                }

                if (this._machine == null) {
                    this.log("ERROR no machine");
                }

                if (this._winAnimator == null) {
                    this.log("WARNING no winAnimator");
                }
            }
        }
    }

    disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
    }

    initReceived(controller: FreespinsController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            null,
                            null,
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this._noWinContainer,
                            this._winContainer,
                            this._highWinsAnim,
                        );
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
    }

    initIntro(): void {
        StageController.baseStageContainer.visible = false;
        StageController.baseStage = false;
        StageController.freespinStage = true;

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);

        this.visible = true;

        AmbientBackground.changeAmbientBackground("color-1", 0);

        this.retrigger();
        this.initializeCounters();
        if (GameManager.freespinsResponse.currentWin > 0) {
            this.childs["Counters"].goToCase("WIN_MP");
        }

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSloop");
            PlayList.loop("SND_BaseRecapLoop");
            PlayList.play("SND_FSEnd");

            if (GameManager.freespinsResponse.totalWin > 0) {
                if (FreespinsView.TotalWin != null) {
                    FreespinsView.TotalWin.visible = true;
                    FreespinsView.TotalWin.play(GameManager.freespinsResponse.totalWin);
                }
            }
        } else {
            PlayList.loop("SND_FSloop");
        }
    }

    spin(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        PlayList.loop("SND_FSloop");

        this.updateFsCounter();

        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }

        this._machine.spinStart(this._winAnimator.reset(true), true, this._winAnimator.currentSymbols);
    }

    respin(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        PlayList.loop("SND_FSloop");
        PlayList.play("SND_FSRespin");

        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }

        this._machine.spinStart(this._winAnimator.reset(true), true, this._winAnimator.currentSymbols);
    }

    stop(): void {
        this._machine.spinStop(null, true);
    }

    startReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    endReceived(): void {}

    onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    machineStopped(): void {
        this._controller.machineStopped();

        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.stop("SND_FSloop");
        }

        if (GameManager.freespinsResponse.currentWin > 0) {
            this.childs["Counters"].goToCase("WIN_MP");
            PlayList.play("SND_PickupAdd02FS");
        }

        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                PlayList.stop("SND_FSloop");
                PlayList.loop("SND_BaseRecapLoop");
                PlayList.play("SND_FSEnd");
                if (GameManager.freespinsResponse.totalWin > 0) {
                    if (FreespinsView.TotalWin != null) {
                        FreespinsView.TotalWin.visible = true;
                        FreespinsView.TotalWin.play(GameManager.freespinsResponse.totalWin);
                    }
                }
            }
        }
    }

    finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        this._controller.allWinsFinished();

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSloop");
            PlayList.loop("SND_BaseRecapLoop");
            PlayList.play("SND_FSEnd");
            if (GameManager.freespinsResponse.totalWin > 0) {
                if (FreespinsView.TotalWin != null) {
                    FreespinsView.TotalWin.visible = true;
                    FreespinsView.TotalWin.play(GameManager.freespinsResponse.totalWin);
                }
            }
        } else {
            PlayList.loop("SND_FSloop");
        }
        this.retrigger();
    }

    intro(long: boolean = false): void {
        this.childs["TransitionHolder"].addChild(BaseView.Transition);
        StageController.baseStageContainer.visible = false;
        StageController.baseStage = false;
        StageController.freespinStage = true;
        BaseView.Transition.goToCase("END");

        this.visible = true;

        AmbientBackground.changeAmbientBackground("color-1", 400);

        this.initializeCounters();

        this._introDelay.start(40);
    }

    introFinished(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        this.visible = true;

        PlayList.loop("SND_FSloop");

        this._controller.introFinished();

        /* soft reload fix */
        let i: number = 0;
        if (WinAnimator2.Symbols != null) {
            for (i = 0; i < WinAnimator2.Symbols.length; i++) {
                for (let j: number = 0; j < WinAnimator2.Symbols[i].length; j++) {
                    if (
                        WinAnimator2.Symbols[i][j] != null &&
                        (WinAnimator2.Symbols[i][j].visible || WinAnimator2.Symbols[i][j].alpha === 1)
                    ) {
                        Tweens.removeTweens(WinAnimator2.Symbols[i][j]);
                        WinAnimator2.Symbols[i][j].alpha = 1;
                    }
                }
            }
        }
    }

    outro(): void {
        StageController.freespinStage = true;
        this._winAnimator.reset(true);

        this.visible = true;

        PlayList.stop("SND_FSloop");
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.play("SND_FSTransition");
        if (FreespinsView.TotalWin != null) {
            FreespinsView.TotalWin.visible = false;
        }

        this.childs["TransitionHolder"].addChild(BaseView.Transition);
        BaseView.Transition.setDynamicTime(0);
        BaseView.Transition.goToCase("START");
        this._outroDelay.start(120);
    }

    outroFinished(): void {
        StageController.freespinStage = false;

        this.visible = false;

        AmbientBackground.changeAmbientBackground("base", 400);

        this._controller.outroFinished();
    }

    enable(): void {}

    private retrigger(): void {
        if (!this.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                        // TODO retrigger
                    }
                }
            }
        }
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0 &&
            !this.isRespin()
        );
    }

    private isRespin(): boolean {
        return (
            GameManager.freespinsResponse != null &&
            GameManager.freespinsResponse.respin != null &&
            GameManager.freespinsResponse.respin !== 0
        );
    }

    private initializeCounters(intro: boolean = false): void {
        if (this._counters != null && GameManager.freespinsResponse != null) {
            this.updateCounterValue(
                <SwitchElement>this._counters.getChildElementByName("FSCounter"),
                GameManager.freespinsResponse.freeSpins.remainingCount,
            );
            this.updateCounterValue(
                <SwitchElement>this._counters.getChildElementByName("MLPCounter"),
                GameManager.freespinsResponse.freeSpins.multiplier,
            );

            this._counters.goToCase(intro ? "SHOW" : "NORMAL");
        }
    }

    private updateFsCounter(): void {
        if (this._counters != null && GameManager.freespinsResponse != null) {
            const value = GameManager.freespinsResponse.freeSpins.remainingCount - 1;
            this.updateCounterValue(<SwitchElement>this._counters.getChildElementByName("FSCounter"), value);
            this._counters.goToCase("POP_FS" + (value == 0 ? "_OUT" : ""));
            PlayList.play("SND_PickupAdd01FS");
        }
    }

    private updateCounterValue(counterHolder: SwitchElement, value: number): void {
        if (counterHolder != null) {
            let counterElement = <ImageTextCounterElement>counterHolder.getChildElementByName("Counter");
            if (counterElement != null) {
                counterElement.setBitmapText(value);
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/